<template>
  <div class="confirmPopup">
    <van-dialog v-model="show" :show-confirm-button="false">
      <div class="dialogContent">
        <div class="title">身份信息确认</div>
        <!--确认信息-->
        <div class="confirmInfo">
          <div class="infoItem">
            <div class="label">姓名</div>
            <input
              type="text"
              v-model="userInfo.ocrName"
              placeholder="请输入姓名"
            />
          </div>
          <div class="infoItem">
            <div class="label">身份证号</div>
            <input
              type="text"
              v-model="userInfo.ocrCardNo"
              placeholder="请输入身份证号"
            />
          </div>
           <!--生效日期-->
          <startTimeField label="生效日期" v-model="startTime" />
          <!--是否长期-->
          <long-time-field label="是否长期" v-model="isLongTime" />
          <!--失效日期-->
          <div v-show="!isLongTime">
            <endTimeField label="失效日期" v-model="endTime" />
          </div>
        </div>
        <div class="protocol-wrap">
          <!--信息确认协议-->
          <protocolField
            protocol="idCardBinding"
            v-model="isChecked"
            routerName="idCardBinding"
            protocolType="4"
            alignItems="flex-start"
          />
        </div>
        <Popupagr
          ref="popupagr"
          message="请先阅读并同意相关协议"
          confirmText="同意并继续"
          cancelText="不同意"
          @confirm="handleConfirm"
        />
        <!--确认按钮-->
        <div class="confirmBtn">
          <div class="submitBtn" @click="handleSubmitClick">提交申请</div>
          <div class="cancelBtn" @click="show = false">取消</div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import protocolField from "@/components/protocolField/index.vue";
import { formatIdCardDate } from "@/utils/utils";
// 确保项目已安装并引入了 Vant
import { Popup, DatetimePicker, Toast } from "vant";
import Popupagr from "@/components/Popup/index.vue";
import { sign } from "@/api/index.js";
import { formatDate, parseDateString } from "@/common/index.js";
import startTimeField from "@/components/idCardBinding/startTimeField.vue";
import endTimeField from "@/components/idCardBinding/endTimeField.vue";
import longTimeField from "@/components/idCardBinding/longTimeField.vue";

export default {
  components: {
    protocolField,
    Popupagr,
    startTimeField,
    endTimeField,
    longTimeField,
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker,
    [Toast.name]: Toast,
  },
  data() {
    return {
      show: false,
      userInfo: {},
      isChecked: false,
      formatIdCardDate,
      showPopup: false,
      currentTab: "start", // 当前正在选择 'start' 还是 'end'
      startTime: "",
      endTime: "",
      currentDate: new Date(),
      minDate: new Date(1990, 0, 1),
      maxDate: new Date(2100, 0, 1),
      isLongTime: false,
    };
  },
  methods: {
    init(){
      this.show = true;
      setTimeout(() => {
        this.handleShowDate();
      }, 300);
    },
    // 展示有效期弹窗
    handleShowDate(){
      if(this.userInfo.expireDate){
        let start = formatDate(this.userInfo.expireDate.slice(0,8));
        let end = formatDate(this.userInfo.expireDate.slice(8,16));
        this.startTime = start;
        this.endTime = end;
        this.currentDate = parseDateString(this.currentTab == "start" ? start : end);
      }
      this.showPopup = true;
    },
    //同意并继续登录
    handleConfirm() {
      this.isChecked = true;
    },
    // 格式化时间对象为字符串
    formatDate(date) {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const d = String(date.getDate()).padStart(2, "0");
      return `${y}-${m}-${d}`;
    },
    async handleSubmitClick() {
      if (!this.isChecked) {
        this.$refs.popupagr.showPopup();
        return;
      }
      //调用签署协议接口
      await sign({configIds: this.$store.state.agreementList.map(item => item.configId)});
      this.show = false;
      if(this.startTime && this.endTime){
        this.$emit("submitClick", {...this.userInfo, expireDate: this.startTime.split("-").join("") + this.endTime.split("-").join("")});
      }else{
        this.$emit("submitClick", this.userInfo);
      }
      
    },
  },
};
</script>

<style scoped lang="scss">
.dialogContent {
  background: linear-gradient( 180deg, #FFF0F0 0%, #FFFFFF 10.99%);
  position: relative;
  border-radius: 8px 8px 0 0;
  padding: 12px 0px;
}
.title {
  text-align: center;
  font-size: 18px;
  color: #333333;
  font-weight: 600;
}
.confirmInfo {
  padding: 0px 27px;
}
.infoItem {
  padding: 10px;
  font-size: 14px;
  color: #333333;
  background: #F9F9F9;
  border-radius: 27px;
  margin-top: 16px;
  display: flex;
  align-items: center;
  .label {
    width: 70px;
    color: #777777;
  }
  input {
    flex: 1;
    font-size: 14px;
    color: #333333;
    border: none;
    outline: none;
    background: transparent;
  }
}
.protocol-wrap {
  padding: 0px 27px;
}
.confirmBtn {
  padding: 0px 27px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
  .submitBtn {
    font-size: 16px;
    color: #fff;
    background: #F24334;
    border-radius: 30px;
    width: 100%;
    height: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .cancelBtn {
    font-size: 16px;
    color: #777777;
    width: 203px;
    height: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.home-title {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 16px;
  left: 16px;
}
.home-title img {
  width: 36px;
  margin-right: 8px;
}
.home-title span {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 20px;
  color: #1d70f7;
}
.title-img {
  position: absolute;
  top: 16px;
  right: 16px;
  img {
    width: 71px;
    height: 71px;
  }
}
.popup-header {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 15px 10px;
  font-size: 14px;
  border-bottom: 1px solid #f2f3f5;
}
.popup-header .active {
  color: #1989fa;
  font-weight: bold;
}
.separator {
  color: #969799;
}
</style>
